import React from 'react';
import { Box, Container, Typography, Stack, Button } from '@mui/material';
import SectionWrapper from '../SectionWrapper';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * OVERVIEW CTA COMPONENT - V8 (CINEMATIC POLISH)
 * Concept: "Execution Command".
 * Updates: Glassmorphism HUD, Magnetic Interactions.
 */
const OverviewCTA = () => {
    return (
        <SectionWrapper
            id="cta-genesis"
            className="section-cta"
            sx={{
                bgcolor: '#FFFFFF',
                color: '#000000',
                borderTop: '1px solid #E5E5E5'
            }}
        >
            <Container maxWidth={false} sx={{ maxWidth: '1200px', mx: 'auto', position: 'relative', zIndex: 1, py: { xs: 8, md: 10 } }}>

                {/* HEADLINE BLOCK */}
                <Stack spacing={4} sx={{ maxWidth: '900px' }}>

                    {/* SYSTEMS STATUS INDICATOR REMOVED PER REFINEMENT V3 */}

                    <Typography variant="h1" sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontSize: { xs: '3.5rem', md: '6rem' },
                        fontWeight: 800,
                        lineHeight: 0.9,
                        letterSpacing: '-0.04em',
                        color: '#000'
                    }}>
                        TRANSFORME<br />
                        TECNOLOGIA<br />
                        <Box component="span" sx={{ color: '#CC0000' }}>EM RESULTADOS.</Box>
                    </Typography>

	                    <Typography variant="body1" sx={{
	                        fontFamily: '"JetBrains Mono", monospace',
	                        fontSize: { xs: '1rem', md: '1.25rem' },
	                        color: '#666',
	                        maxWidth: '600px',
	                        pt: 2
	                    }}>
	                        {'//Inicie a transformação digital'}
	                        <br />
	                        {'//fale com um de nossos arquitetos'}
	                    </Typography>

                    {/* ACTION AREA */}
                    <Box sx={{ pt: 4 }}>
                        <Button
                            component={RouterLink} to="/fale-conosco"
                            variant="outlined"
                            size="large"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                fontFamily: '"JetBrains Mono", monospace',
                                fontSize: '1.25rem',
                                borderColor: 'black',
                                color: 'black',
                                borderRadius: '14px',
                                px: 6, py: 2, // Adjusted padding to match detailed look but lighter
                                textTransform: 'none',
                                borderWidth: '1px',
                                '&:hover': {
                                    bgcolor: 'rgba(0, 0, 0, 0.05)',
                                    borderColor: 'black',
                                    borderWidth: '1px'
                                },
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Fale Conosco
                        </Button>
                    </Box>
                </Stack>

            </Container>

            {/* BACKGROUND NOISE / GRID */}
            <Box sx={{
                position: 'absolute',
                top: 0, left: 0, width: '100%', height: '100%',
                backgroundImage: 'linear-gradient(#E5E5E5 1px, transparent 1px), linear-gradient(90deg, #E5E5E5 1px, transparent 1px)',
                backgroundSize: '100px 100px',
                opacity: 0.4,
                pointerEvents: 'none'
            }} />
        </SectionWrapper>
    );
};

export default OverviewCTA;
